import React from 'react';
import imgResolver from '../../../utils/img-resolver';
import Week from './Week';
import DayNames from './DayNames';
import moment from 'moment';

class Calendar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            month: moment().startOf("day"),
        };
    }

    getSelection(date) {
        let selected = this.props.selected;
        const formattedDate = date.format('YYYY-MM-DD');
        const index = selected.indexOf(formattedDate);

        if (index > -1) {
            selected.splice(index, 1);
        } else {
            selected.push(formattedDate);
        }

        this.props.onChange(selected.join('|'));
    }

    monthChangeCallback(date) {}

    prevMonth() {
        const newMonth = this.state.month.add(-1, "M");
        this.monthChangeCallback(newMonth);
        this.setState({
            month: newMonth
        });
    }

    nextMonth() {
        const newMonth = this.state.month.add(1, "M");
        this.monthChangeCallback(newMonth);
        this.setState({
            month: newMonth
        });
    }

    select(day) {
        const state = {};
        if (day.isNextMonth) {
            state.month = this.state.month.add(1, "M");
            this.monthChangeCallback(state['month']);
        } else if (day.isPrevMonth) {
            state.month = this.state.month.add(-1, "M");
            this.monthChangeCallback(state['month']);
        }
        this.getSelection(day.date);
        this.setState(state);
        this.forceUpdate();
    }

    render() {
        return (
            <div className="calendar calender-input">
                <div className="calendar-header media">
                    <button className="calendar-arrow calendar-left left" type="button" onClick={this.prevMonth.bind(this)}></button>
                        <span className="calendar-header-month body">
                            {this.state.month.format("MMMM, YYYY")}
                            <img className="calendar-icon" src={require('../../../styles/images/icon-calendar.svg')} alt="Gigpanel" />
                        </span>
                    <button className="calendar-arrow calendar-right right" type="button" onClick={this.nextMonth.bind(this)}></button>
                </div>
                <div className="calendar-body">
                    <DayNames />
                    {this.renderWeeks()}
                </div>
            </div>
        );
    }

    renderWeeks() {
        var weeks = [];
        var done = false;
        const DOW_MONDAY = 1;
        var date = this.state.month.clone().startOf("month").day(DOW_MONDAY);
		var monthIndex = date.month();
		var count = 0;
        var disableBefore = this.props.disableBefore || null;

		while (!done) {
			weeks.push(
                <Week key={date.toString()}
                      date={date.clone()}
                      month={this.state.month}
                      select={this.select.bind(this)}
                      selected={this.props.selected}
                      disableBefore={disableBefore}
                    />
            );
			date.add(1, "w");
			done = count++ > 2 && monthIndex !== date.month();
			monthIndex = date.month();
		}

        return weeks;
    }
}
export default Calendar;



/** WEBPACK FOOTER **
 ** ./app/src/components/Form_widgets/Calendar/Calendar.js
 **/